import { GameDifficultyId } from '@/models/game/difficulty/id';

export function getMissionUncrossableAnimationDuration(difficulty: bigint) {
  switch (difficulty?.toString()) {
    case GameDifficultyId.MissionUncrossableEasy.toString():
      return 5000;
    case GameDifficultyId.MissionUncrossableMedium.toString():
      return 3500;
    case GameDifficultyId.MissionUncrossableHard.toString():
      return 2500;
    case GameDifficultyId.MissionUncrossableDaredevil.toString():
      return 1500;
    default:
      return 5000;
  }
}
